<template>
    <toolbar-option>
        <template slot="primary">
            <input
                v-model="value"
                type="text"
                placeholder="Add default value"
                @change="setChangedData(true)"
            >
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'input-default-value',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Input Value',
            value: '',
        };
    },

    watch: {
        value() {
            this.selectedElements[0].inputValueNew = this.value;
            this.onOptionChange(this.value);
        },
    },

    methods: {
        onSelectedElement() {
            this.value = this.selectedElements[0].inputValueNew;
        },
    },
};
</script>
